import {
  format,
  formatDuration,
  intervalToDuration,
  isSameDay,
  isToday,
  isTomorrow,
  isYesterday,
  parseISO,
} from 'date-fns';

export const prettyDateString = (
  inputDate: string | number | Date | null | undefined,
  formatString = 'iiii do LLLL yyyy',
) => {
  if (!inputDate) {
    return '';
  }

  const date = new Date(inputDate);

  return isToday(date)
    ? 'today'
    : isTomorrow(date)
      ? 'tomorrow'
      : isYesterday(date)
        ? 'Yesterday'
        : format(date, formatString);
};

export const prettyDurationDate = (start: Date, end: Date) => {
  return formatDuration(intervalToDuration({ start, end }));
};

export const prettyDuration = (start: string, end: string) => {
  const startDate = parseISO(start);
  const endDate = parseISO(end);

  const duration = prettyDurationDate(startDate, endDate);

  return duration;
};

export const prettyDateDuration = (start: string, end: string) => {
  const startDate = parseISO(start);
  const endDate = parseISO(end);

  const startString = format(startDate, 'iiii do LLLL yyyy H:mm');
  const endString = format(
    endDate,
    isSameDay(startDate, endDate) ? 'H:mm' : 'iiii do LLLL yyyy H:mm',
  );

  const duration = formatDuration(
    intervalToDuration({ start: startDate, end: endDate }),
  );

  return `${startString} - ${endString} (${duration})`;
};
